import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagebreak',
  templateUrl: './pagebreak.component.html',
  styleUrls: ['./pagebreak.component.css']
})
export class PagebreakComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
